export default {
  qHyperCubeDef: {
    qDimensions: [
      {
        qDef: {
          qFieldDefs: ['team_name'],
          qFieldLabels: ['Team'],
          qSortCriterias: [{ qSortByState: 1, qSortByExpression: -1, qExpression: { qv: "Count({<team_tournament_position = {'1'},  team_name=>} team_tournament_position)" } }],
        },
        qNullSuppression: true,
      },
      {
        qDef: { qFieldDefs: ['total_match_wins'], qFieldLabels: ['Won'] },
        qAttributeExpressions: [
          {
            qExpression: 'Sum(Aggr((if(home_team_id = team_id, only(home_team_win), 0) + if(away_team_id = team_id, only(away_team_win), 0)), match_id))',
          },
        ],
        qNullSuppression: true,
      },
    ],
    qMeasures: [
      {
        qDef: { qDef: "Count({<team_tournament_position = {'1'},  team_name=>} team_tournament_position)", autoSort: false, qLabel: 'Winner' },
        qSortBy: { qSortByNumeric: -1 },
      },
      {
        qDef: { qDef: "Count({<team_tournament_position = {'2'},  team_name=>} team_tournament_position)", autoSort: false, qLabel: 'Runner-up' },
        qSortBy: { qSortByNumeric: -1 },
      },
      {
        qDef: { qDef: "Count({<team_tournament_position = {'3'},  team_name=>} team_tournament_position)", autoSort: false, qLabel: '3rd Place' },
        qSortBy: { qSortByNumeric: -1 },
      },
      {
        qDef: { qDef: 'Count({< team_name=>} distinct tournament_id)', autoSort: false, qLabel: 'Participations' },
        qSortBy: { qSortByNumeric: -1 },
      },
      {
        qDef: { qDef: 'Count({< team_name=>} distinct match_id)', autoSort: false, qLabel: 'Games Played' },
        qSortBy: { qSortByNumeric: -1 },
      },
      {
        qDef: {
          qDef: 'Only({< team_name=>} total_match_wins) / Count({< team_name=>} distinct match_id)',
          autoSort: false,
          qLabel: 'Win Rate',
          qNumFormat: {
            qType: 'I',
            qnDec: 0,
            qUseThou: 1,
            qFmt: ',.0%',
            qDec: ',',
          },
        },
        qSortBy: { qSortByNumeric: -1 },
      },
      {
        qDef: { qDef: 'Count({< team_name=>} distinct goal_id)', autoSort: false, qLabel: 'Goals' },
        qSortBy: { qSortByNumeric: -1 },
      },
      {
        qDef: { qDef: 'Sum({< team_name=>} yellow_card)', autoSort: false, qLabel: 'Yellow Cards' },
        qSortBy: { qSortByNumeric: -1 },
      },
      {
        qDef: { qDef: 'Sum({< team_name=>} red_card) + sum({< team_name=>} second_yellow_card)', autoSort: false, qLabel: 'Red Cards' },
        qSortBy: { qSortByNumeric: -1 },
      },
    ],
    qInitialDataFetch: [{
      qWidth: 11,
      qHeight: 900,
    }],
  },
};
